<template>
  <div class="setting-row">
    <div class="setting-label">
      <span class="label-text">
        <v-icon small class="wind-icon" v-if="isWind">mdi-weather-windy</v-icon>
        {{ label }}
      </span>
    </div>
    <div class="setting-value">
      <div class="switch-container">
        <v-switch
          :input-value="value"
          @change="$emit('change', $event)"
          hide-details
          :color="value ? '#4A7EBA' : '#E0E0E0'"
          class="clean-switch"
        >
          <template v-slot:label>
            <span class="switch-label">
              {{ value ? 'Enabled' : 'Disabled' }}
            </span>
          </template>
        </v-switch>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TitledSwitchField",
  props: {
    value: Boolean,
    label: {
      type: String,
      default: "Switch"
    },
    isWind: {
      type: Boolean,
      default: false
    }
  },
  emits: ['change']
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500&display=swap'); /* Replace with your font */

.setting-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #F8F8F8;
  font-family: 'Roboto', sans-serif; /* Replace with γραμματοσειρα */
}

.setting-label {
  flex: 1;
}

.label-text {
  font-size: 0.9rem;
  font-weight: 500;
  color: #FFFFFF; /* white labels */
  display: flex;
  align-items: center;
}

.wind-icon {
  margin-right: 6px;
  color: #4A7EBA; /* icon color */
}

.setting-value {
  flex-shrink: 0;
}

.switch-container {
  display: flex;
  align-items: center;
}

.clean-switch {
  margin: 0;
  padding: 0;
}

.clean-switch :deep(.v-input--selection-controls__input) {
  transform: scale(0.9);
}

.clean-switch :deep(.v-input--switch__track) {
  height: 16px;
  border-radius: 8px;
  width: 28px;
}

.clean-switch :deep(.v-input--switch__thumb) {
  background-color: #FFFFFF;
  width: 12px;
  height: 12px;
}

.switch-label {
  font-size: 0.8rem;
  font-weight: 500;
  color: #FFFFFF; /* always white */
  margin-left: 8px;
}
</style>
